import { generatePath } from 'react-router';

import { useMemo } from 'react';
import { Flag } from '@utils';
import { IntegrationConfigAppModelV2, IntegrationFamilyType } from '@api';
import { useFlagFixed } from '@hooks';
import { routes } from '@routes';

export const useIntegrationSummaryRedirectLink = (
  integrationConfig: IntegrationConfigAppModelV2 | undefined,
  integrationId: string,
  failed: number,
) => {
  const resourcesRedirectLink = useResourcesRedirectLink(integrationId, failed > 0);
  const link = useMemo(() => {
    if (integrationConfig?.family_type === IntegrationFamilyType.WebhookIntegration) {
      return `${generatePath(routes.Webhooks.path)}?integration-id=${integrationId}`;
    } else if (
      integrationConfig?.family_type === IntegrationFamilyType.IdentityProvider ||
      integrationConfig?.family_type === IntegrationFamilyType.IdentityContext
    ) {
      return routes.Identities.path;
    } else {
      return resourcesRedirectLink;
    }
  }, [integrationConfig, integrationId, resourcesRedirectLink]);

  return link;
};

export const useResourcesRedirectLink = (integrationId: string, failed = false) => {
  const { isEnabled: isInventoryEnabled } = useFlagFixed(Flag.SHOW_INVENTORY);

  const link = useMemo(() => {
    if (!integrationId) {
      return '';
    }
    if (!isInventoryEnabled) {
      const resourceLink = generatePath(routes.IntegrationResources.path, { id: integrationId });
      return failed ? `${resourceLink}?search=error` : resourceLink;
    }
    const query = `integration = "${integrationId}"${failed ? ' AND resource_status = "ERROR"' : ''}`;
    return `${generatePath(routes.Inventory.path)}?query=${encodeURIComponent(query)}`;
  }, [isInventoryEnabled, integrationId, failed]);

  return link;
};
